<template>
  <a-modal v-model="visible" :title="$t('设置角色')" :width="1000">
    <div slot="footer">
      <a-button @click="visible = false">{{ $t('取消') }}</a-button>
      <a-button :loading="loading" type="primary" @click="handleCommit">{{ $t('保存') }}</a-button>
    </div>
    <a-form-model ref="form" :model="form" :rules="rules" :labelCol="{ span: 4 }" :wrapperCol="{ span: 18 }">
      <a-row>
        <a-col :span="24">
          <a-form-model-item :label="$t('角色')" prop="roles">
            <a-select v-model="form.roles" :options="roleOptions" mode="multiple" />
          </a-form-model-item>
        </a-col>
      </a-row>
    </a-form-model>
  </a-modal>
</template>
<script>
import { saveRoles } from '@/api/user/user'
import { getRoleList } from '@/api/system/role'

export default {
  data() {
    return {
      visible: false,
      form: {},
      loading: false,
      roleOptions: [],
    }
  },
  computed: {
    userInfo() {
      return this.$store.getters.user
    },
    rules() {
      const result = {
        name: [{ required: true, message: this.$t('请输入') }],
        loginName: [{ required: true, message: this.$t('请输入') }],
      }
      return result
    }
  },
  created() {

  },
  methods: {
    loadOptions() {
      getRoleList({ appId: this.form.appId }).then(res => {
        if (res.code === 0) {
          this.roleOptions = res.data.map(e => ({
            label: e.name,
            value: e.id
          }))
        }
      })
    },
    show(data) {
      this.form = { ...data }
      this.form.roles = this.form.roles?.map(e => e.id) ?? []
      this.loadOptions()
      this.visible = true
    },
    handleCommit() {
      this.$refs.form.validate((success) => {
        if (!success) {
          return
        }
        this.loading = true
        const commitData = {
          id: this.form.id,
          roles: this.form.roles?.map(e => ({ id: e })) || []
        }
        saveRoles(commitData).then(res => {
          if (res.code === 0) {
            this.$message.success(this.$t('保存成功'))
            this.$emit('ok', this.form)
            this.visible = false
          } else {
            this.$message.error(res.message || this.$t('保存失败'))
          }
        }).catch(err => {
          this.$message.error(this.$t('保存失败'))
        }).finally(() => {
          this.loading = false
        })
      })
    }
  }
}
</script>